import { AppStatusConfig, selectAppStatusConfig } from 'core/config/firebase/remote-config-slice';
import { useAppSelector } from './use-app-selector';

const useAppStatusConfig = (): AppStatusConfig => useAppSelector(selectAppStatusConfig);

export { useAppStatusConfig };
export type { AppStatusConfig } from 'core/config/firebase/remote-config-slice';
